import { ref } from 'vue'; // Removed onMounted, onUnmounted
import { auth } from '../firebaseConfig'; // Assuming firebaseConfig.js is in src
import { onAuthStateChanged, signOut as firebaseSignOut } from 'firebase/auth';

const currentUser = ref(null);
const loading = ref(true); // To track initial auth state loading

// Listen to Firebase auth state changes
// This listener is set up once when the module is imported.
const unsubscribeAuthStateListener = onAuthStateChanged(auth, (user) => {
  currentUser.value = user;
  loading.value = false;
  // console.log('Auth state changed, user:', user ? user.email : 'null');
});

// Note: For a long-lived SPA, `unsubscribeAuthStateListener()` might be called
// if the entire app is torn down, but typically this listener persists.

export function useAuth() {
  const signOut = async () => {
    try {
      await firebaseSignOut(auth);
      // currentUser.value will be updated by onAuthStateChanged
      // console.log('User signed out');
    } catch (error) {
      console.error("Error signing out: ", error);
      // Handle sign-out errors if necessary
    }
  };

  return {
    currentUser, // Reactive ref for the current user object (or null)
    loading,     // Reactive ref to indicate if initial auth state is loading
    signOut      // Function to sign out the current user
    // The listener is managed at the module level now
  };
}